
import dateFormatMixin from '@/mixins/dateFormat'

import TrustPilotLogo from '@/static/svg/reviews/trust-pilot-logo.svg'
import TrustPilotLogoStars from '@/static/svg/reviews/trust-pilot-logo-stars.svg'
import ETrustedLogo from '@/static/svg/reviews/e-trusted-logo.svg'
import ETrustedStars from '@/static/svg/reviews/e-trusted-stars.svg'
import LoadingSpinner from '@/components/LoadingSpinner'
import ReviewStars from '@/components/ReviewStars'
import HeroButton from '@/components/HeroButton'

export default {
  components: {
    TrustPilotLogo,
    TrustPilotLogoStars,
    ETrustedLogo,
    ETrustedStars,
    LoadingSpinner,
    ReviewStars,
    HeroButton,
  },
  mixins: [dateFormatMixin],
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
    average: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadMore: {
      type: Boolean,
      default: true,
    },
  },
}
